import React, { useCallback } from 'react';
import styles from './AvatarSelect.module.css';
import { AvatarSelectElement } from '../AvatarSelectElement';

export const DesktopView = (): JSX.Element => {
  // Redux Hooks

  const avatarSelectElement = AvatarSelectElement();
  return (
    <>
      <div
        className={styles.chooseYourAvatarTitleDiv}
        id="choose-your-avatar-title"
      >
        <div
          className={styles.chooseYourAvatarTitleTextDiv}
          id="choose-your-avatar-title-text"
        >
          choose your avatar
        </div>
      </div>
      <div
        className={styles.chooseYourAvatarMainGroupDiv}
        id="choose-your-avatar-main-group"
      >
        <div className={styles.chooseYourAvatarMainGroupDiv}>
          <div className={styles.avatarRowDiv}>
            {avatarSelectElement.avatarSelectionBox}
            {/* <div className={styles.firstRowDiv}>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody@2x.png"
                    />
                    <img className={styles.selectedIcon} alt="" />
                  </div>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody1@2x.png"
                    />
                    <img className={styles.selectedIcon} alt="" />
                  </div>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody2@2x.png"
                    />
                    <img
                      className={styles.selectedIcon2}
                      alt=""
                      src="selected.svg"
                    />
                  </div>
                </div>
                <div className={styles.firstRowDiv}>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody3@2x.png"
                    />
                    <img className={styles.selectedIcon} alt="" />
                  </div>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody4@2x.png"
                    />
                    <img className={styles.selectedIcon} alt="" />
                  </div>
                  <div className={styles.avatarIconDiv}>
                    <img
                      className={styles.avatarCodyIcon}
                      alt=""
                      src="avatarcody5@2x.png"
                    />
                    <img className={styles.selectedIcon} alt="" />
                  </div>
                </div> */}
          </div>
        </div>
      </div>
      <div
        className={styles.chooseYourAvatarFooterDiv}
        id="choose-your-avatar-footer"
      >
        <div className={styles.createChildProfileMainGrouButton}>
          {avatarSelectElement.backButton}
        </div>
        <div
          className={styles.chooseYourAvatarSaveButton}
          id="choose-your-avatar-save-button"
        >
          {avatarSelectElement.saveButton}
        </div>
      </div>
    </>
  );
};
